import React, { useEffect, useState } from 'react';
import { MessageCircle } from 'lucide-react';
import { waGeneral } from '../config/pricing';

const encode = (data) => new URLSearchParams(data).toString();

export default function Success() {
  const [notice, setNotice] = useState('');

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const sessionId = params.get('session_id');
    if (!sessionId || sessionStorage.getItem(`ma-order-sent-${sessionId}`)) return;

    const sendOrderNotification = async () => {
      try {
        const res = await fetch(`/.netlify/functions/order-details?session_id=${encodeURIComponent(sessionId)}`);
        if (!res.ok) return;
        const order = await res.json();
        await fetch('/', {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: encode({
            'form-name': 'order-notification',
            order_id: order.orderId,
            payment_intent: order.paymentIntent,
            customer_name: order.customerName,
            customer_email: order.customerEmail,
            customer_phone: order.customerPhone,
            shipping_name: order.shippingName,
            shipping_address: order.shippingAddress,
            billing_address: order.billingAddress,
            order_items: order.items,
            order_total: `${order.currency} ${order.amount}`,
            notify_email: order.ownerEmail,
          }),
        });
        sessionStorage.setItem(`ma-order-sent-${sessionId}`, '1');
        setNotice('Order details have been sent for fulfilment.');
      } catch {
        setNotice('Payment confirmed. If needed, message us on WhatsApp with your order email.');
      }
    };

    sendOrderNotification();
  }, []);

  return (
    <div className="page-pad">
      <div className="page-card">
        <div className="seal">M</div>
        <h1>Order confirmed</h1>
        <p>
          Your payment was successful. Malik's Aroma will prepare your fragrance order and send confirmation by email.
        </p>
        {notice && <p className="setup-note">{notice}</p>}
        <div className="page-actions">
          <a href="/" className="btn btn-gold">Return Home</a>
          <a href={waGeneral()} className="btn btn-ghost" target="_blank" rel="noopener noreferrer">
            <MessageCircle size={14} /> WhatsApp Support
          </a>
        </div>
      </div>
    </div>
  );
}
